import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const USER_PREFERENCES = gql(`
  query userPreferences {
    me {
      __typename
      id
      preferences {
        __typename
        onboardingDisabled
      }
    }
  }
`);

export function useUserPreferences() {
  const { data, ...rest } = useQuery(USER_PREFERENCES);

  const preferences = data?.me.preferences;

  return { ...rest, data: preferences };
}
